var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPullTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 30,
    viewBox: "0 0 14 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.15 -0.95C-0.15 -0.977614 -0.127614 -1 -0.1 -1C-0.0723858 -1 -0.05 -0.977614 -0.05 -0.95V3C-0.05 5.20914 1.74086 7 3.95 7H9.70019C11.9093 7 13.7002 8.79086 13.7002 11V19C13.7002 21.2091 11.9093 23 9.7002 23H3.95C1.74086 23 -0.05 24.7909 -0.05 27V30.95C-0.05 30.9776 -0.0723858 31 -0.1 31C-0.127614 31 -0.15 30.9776 -0.15 30.95V23.0749C-0.15 23.0335 -0.183535 23 -0.224902 23C-0.26627 23 -0.299805 22.9665 -0.299805 22.9251V7.0749C-0.299805 7.03354 -0.26627 7 -0.224902 7C-0.183535 7 -0.15 6.96646 -0.15 6.9251V-0.95Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2249_92948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45703 9.65191L5.58825 9.65191L10.6274 14.8714L5.59654 20.0815L3.46607 20.0815L8.49618 14.8714L3.45703 9.65191Z",
    fill: "#003000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2249_92948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.7333,
    height: 11.7333,
    fill: "currentColor",
    transform: "translate(0.849609 20.7334) rotate(-90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPullTab);
export default __webpack_public_path__ + "static/media/pull-tab.29577ce3.svg";
export { ForwardRef as ReactComponent };